import { render, staticRenderFns } from "./getPay.vue?vue&type=template&id=0a4ad0b7&scoped=true"
import script from "./getPay.vue?vue&type=script&lang=js"
export * from "./getPay.vue?vue&type=script&lang=js"
import style0 from "./getPay.vue?vue&type=style&index=0&id=0a4ad0b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ad0b7",
  null
  
)

export default component.exports